import { Col, ControlLabel, FormGroup, HelpBlock, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import { compose, pure, withHandlers, withState } from "recompose";

import Button from "../../../elements/CustomButton/CustomButton.jsx";
import CategorySelect from "../../Category/CategorySelect";
import ClientProjectSelect from "../../ClientProject/ClientProjectSelect";
import CurrencyInput from "../../Currency/CurrencyInput";
import { FIXED2 } from "../../../tools/fixedTools";
import { FormattedMessage } from "react-intl";
import Queries from "../../../queries/queries2";
import React from "react";
import Spinner from "../../../elements/Spinner/Spinner";
import TierSelect from "../../Tier/TierSelect";
import { graphql } from "react-apollo";
import Checkbox from "../../../elements/CustomCheckbox/CustomCheckbox.jsx";


const toolTipMissingExpense = (
  <Tooltip id="tooltip">
    <p>
      <FormattedMessage id="ids_missingExpense_text" />
    </p>
  </Tooltip>
);

const toolTipMissingInvoice = (
  <Tooltip id="tooltip">
    <p>
      <FormattedMessage id="ids_missingInvoice_text" />
    </p>
  </Tooltip>
);


const withTaxValue = withState(
  "withTaxValue",
  "setWithTaxValue",
  ({ line }) => !!line.valueTax
);

const tiersForSelect = withState(
  "tiersForSelect",
  "setTiersForSelect",
  ({ line }) => {
    const cat = line.categoryIds;
    if (cat) {
      if (
        cat === "ids_clients" ||
        cat === "ids_suppliers" ||
        cat === "ids_collaborators"
      ) {
        return cat;
      }
    }
    return {};
  }
);

const handlers = withHandlers({
  onCategoryChange: ({
    onLineValueChange,
    setWithTaxValue,
    setTiersForSelect
  }) => value => {
    if (!value) {
      onLineValueChange("categoryId", value);
      return;
    }
    if (
      value.element.categoryFamily.ids === "ids_clients" ||
      value.element.categoryFamily.ids === "ids_suppliers" ||
      value.element.categoryFamily.ids === "ids_collaborators"
    ) {
      setTiersForSelect(value.element.categoryFamily.ids);
      setWithTaxValue(false);
      onLineValueChange("projectId", null);
      onLineValueChange("tiersClientId", null);
      onLineValueChange("taxValue", null);
    } else {
      setTiersForSelect("");
      setWithTaxValue(true);
      onLineValueChange("tiersId", null);
    }
    onLineValueChange("categoryId", value && value.element);
  }
});

// const data = graphql(Queries.getExchangeRate, {
//   options: ({ date, currencyId, companyCurrencyId }) => {
//     return {
//       fetchPolicy: "cache-and-network",
//       variables: { date, currencyId, companyCurrencyId }
//     };
//   }
// });

const exchangeRateForTiers = graphql(Queries.getExchangeRate, {
  name: "exchangeRateForTiers",
  options: ({ date, currencyId, companyCurrencyId, line }) => {
    return {
      fetchPolicy: "cache-and-network",
      variables: { date, currencyId, companyCurrencyId: (line.tiers && line.tiers.currency && line.tiers.currency.id) || companyCurrencyId }
    };
  }
});

const PaymentAffectationFields = ({
  // data: { getExchangeRate },
  getExchangeRate,
  line,
  removeLine,
  currencyId,
  companyId,
  onLineValueChange,
  index,
  onCategoryChange,
  withTaxValue,
  sensTransaction,
  tiersForSelect,
  companyDefaultInfos,
  sendNotification,
  error,
  nonLettre,
  history,
  currency,
  exchangeRateForTiers
}) => {
  console.log("PaymentAffectationFields", companyId);

  console.log("tiersForSelect", tiersForSelect);

  const showSuppliers = tiersForSelect && tiersForSelect === "ids_suppliers";
  const showCollaborators =
    tiersForSelect && tiersForSelect === "ids_collaborators";
  const showClients = tiersForSelect && tiersForSelect === "ids_clients";

  console.log(
    "showSuppliers",
    showSuppliers,
    "- showCollaborators",
    showCollaborators,
    "- showClients",
    showClients
  );
  let showTiers = showSuppliers || showCollaborators || showClients;

  if (getExchangeRate === undefined) return <Spinner size="lg" fullScreen />;

  // console.log("149 - getExchangeRate=", getExchangeRate.value);
  // console.log("150 - line=", line);
  // console.log("151 - nonLettrene=", nonLettre);

  if ((line.companyCurrencyAmount === null || line.companyCurrencyAmount === 0) && line.amount !== 0) {
    line.companyCurrencyAmount = FIXED2(line.amount * getExchangeRate.value);
    onLineValueChange("companyCurrencyAmount", line.companyCurrencyAmount);
    // console.log("158 - ...");
  }

  // console.log("159 - companyDefaultInfos.company.currency=", companyDefaultInfos.company.currency);
  // console.log("160 - currencyId=", currencyId);
  // console.log("161 - line=", line);
  // console.log("162 - getExchangeRate=", getExchangeRate);

  return (
    <Row>
      <Col xs={6} sm={3} lg={3}>
        <FormGroup validationState={error ? "error" : null}>
          <ControlLabel>
            <FormattedMessage id="ids_category" />
            <FormattedMessage id="ids_asterisk" />
          </ControlLabel>
          <CategorySelect
            // companyId2={companyId}
            companyId={companyId}
            value={line.categoryId}
            error={error}
            expenseCategory={false}
            supplierCategory
            collaboratorCategory
            clientCategory
            tiersCategory
            invoiceCategory={false}
            creatable
            onSelected={element => {
              console.log("el", element);
              onCategoryChange(element);
            }}
          />
          {error && (
            <HelpBlock>
              <FormattedMessage id="ids_selectACategory" />
            </HelpBlock>
          )}
        </FormGroup>
      </Col>
      {showTiers ? (
        <Col xs={6} sm={3} lg={3}>
          <FormGroup validationState={error ? "error" : null}>
            <ControlLabel>
              <FormattedMessage id="ids_tiers" />
              <FormattedMessage id="ids_asterisk" />
            </ControlLabel>
            <TierSelect
              companyDefaultInfos={companyDefaultInfos}
              companyId={companyId}
              value={line.tiersId}
              sendNotification={sendNotification}
              showSuppliers={showSuppliers}
              showCollaborators={showCollaborators}
              showClients={showClients}
              showComptables={false}
              toto={false}
              error={error}
              onSelected={e => {
                onLineValueChange("tiersId", e && e.value);
              }}
            />
            {error && (
              <HelpBlock>
                <FormattedMessage id="ids_invalidTiers" />
              </HelpBlock>
            )}
          </FormGroup>
        </Col>
      ) : (
        <Col xs={6} sm={3} lg={3}>
          <FormGroup>
            <ControlLabel>
              <FormattedMessage id="ids_clientOrProject" />
            </ControlLabel>
            <ClientProjectSelect
              companyId={companyId}
              filter={{}}
              value={line.tiersClientId ? line.tiersClientId : line.projectId}
              onSelected={e => {
                if (e) {
                  onLineValueChange(
                    e.type === "client" ? "tiersClientId" : "projectId",
                    e.value
                  );
                  onLineValueChange(
                    e.type === "client" ? "projectId" : "tiersClientId",
                    null
                  );
                } else {
                  onLineValueChange("projectId", e);
                  onLineValueChange("tiersClientId", e);
                }
              }}
            />
          </FormGroup>
        </Col>
      )}
      <Col xs={4} sm={2} lg={2}>
        <FormGroup>
          <ControlLabel>
            <FormattedMessage id="ids_amountTTC" />
            <FormattedMessage id="ids_asterisk" />
          </ControlLabel>
          <CurrencyInput
            value={line.amount}
            currencyId={currencyId}
            update={element =>
              onLineValueChange("amount", FIXED2(parseFloat(element.value)))
            }
          />
        </FormGroup>
      </Col>
      {companyDefaultInfos.company.currency.id !== currencyId && (
        <div>
          <Col xs={4} sm={2} lg={2}>
            <FormGroup>
              <ControlLabel>
                <FormattedMessage id="ids_be" />
              </ControlLabel>
              <CurrencyInput
                // bad
                // disabled={true}
                currencyId={companyDefaultInfos.company.currency.id}
                value={line.companyCurrencyAmount || line.amount * getExchangeRate.value}
                update={element =>
                  onLineValueChange("companyCurrencyAmount", FIXED2(parseFloat(element.value)))
                }
              />
            </FormGroup>
          </Col>
        </div>
      )}

      {/* {withTaxValue ? (
        <div>
          <Col xs={3} sm={2}>
            <FormGroup>
              <ControlLabel>
                <FormattedMessage id="ids_recoverableTVA" />
              </ControlLabel>
              <CurrencyInput
                value={line.valueTax}
                currencyId={currencyId}
                update={element =>
                  onLineValueChange("valueTax", parseFloat(element.value))
                }
              />
            </FormGroup>
          </Col>
        </div>
      ) : (
        <Col xs={4} sm={2}>
          <div
            style={{
              marginTop: "38px",
              height: "40px",
              display: "flex",
              alignItems: "center"
            }}>
            <a>
              <FormattedMessage id="ids_seeAffectation" />
            </a>
          </div>
        </Col>
      )} */}
      <Col xs={1} sm={1} lg={1} style={{ marginTop: "48px" }}>
        {index !== 0 ? (

          <Button
            onClick={() => removeLine(index)}
            // style={{ marginTop: "48px" }}
            chip>
            <i style={{ width: "17px" }} className="fa fa-trash" />
          </Button>

        ) : (
          <div />
        )}

        {nonLettre && line.category && line.category.categoryFamily &&
          (
            line.category.categoryFamily.ids === "ids_clients" ||
            line.category.categoryFamily.ids === "ids_suppliers" ||
            line.category.categoryFamily.ids === "ids_collaborators"
          ) ? (
          <OverlayTrigger
            placement="top"
            overlay={
              // row && row.original && row.original.amount > 0
              (line.category.categoryFamily && line.category.categoryFamily.ids === "ids_clients")
                ? toolTipMissingInvoice
                : toolTipMissingExpense
            }
          >
            <i
              onClick={e => {

                history.push({
                  pathname: ((line.category.categoryFamily && line.category.categoryFamily.ids === "ids_clients")
                    ? "/invoices/new"
                    : "/expenses/new"),
                  state: {
                    tiersId: line.tiersId,
                    tiers: line.tiers,
                    amount: Math.abs(line.companyCurrencyAmount || (line.amount * (exchangeRateForTiers.getExchangeRate.value) || 1)), // Math.abs(missingExpenseTiers.amount),
                    currency: (line.tiers && line.tiers.currency) || currency
                  }
                });
              }}
              className={
                (line.category.categoryFamily && line.category.categoryFamily.ids === "ids_clients")
                  ? (
                    line.advancePayment ? "fa text-muted fa-lg fa-file-text" : "fa text-danger fa-lg fa-file-text"
                  )
                  : (
                    line.advancePayment ? "fa text-muted fa-lg fa-shopping-cart" : "fa text-danger fa-lg fa-shopping-cart"
                  )
              }
            />
          </OverlayTrigger>
        ) : (
          <div />
        )}
      </Col>
      {nonLettre ? (
        <Col xs={1} sm={1} lg={1} style={{ marginTop: "36px" }}>
          <Checkbox
            // inline
            number={index}
            isChecked={line.advancePayment}
            label={<FormattedMessage id="ids_advancePayment" />}
            onCheck={value =>
              onLineValueChange("advancePayment", value)}
          />
        </Col>
      ) : (
        <div />
      )}
    </Row>
  );
};

export default compose(
  exchangeRateForTiers,
  withTaxValue,
  tiersForSelect,
  handlers,
  pure
)(PaymentAffectationFields);
